import { useState } from "react";
import useGetItem from "./hooks/useGetItem";
import { useParams } from "react-router-dom";
import useDelete from "./hooks/useDelete";
import useUpdate from "./hooks/useUpdate";
import { Sites } from "data/utils/globals";
import { SchemaData } from "./hooks/types";
import { UpdateGql } from "./queries/update";
import { Forms } from ".";
import { GenericMethods } from "../GenericMethods";
import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { PublicViewButton } from "../publicView";

function Update() {
  const [state, setState] = useState<JsonFormsStateProps<SchemaData>>();
  const id = useParams()?.id;

  if (!id) return null;

  return (
    <GenericMethods.Update<SchemaData, UpdateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      redirectPath={`${Sites.UNIFTEC.path}/forms`}
      useDelete={useDelete}
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={id}
      state={state}
      setState={setState}
      updatePermission={Forms.Permissions.update}
      deletePermission={Forms.Permissions.delete}
    >
      <PublicViewButton
        category="formulario"
        status={state?.data?.status}
        slug={state?.data?.slug}
        publishOn={state?.data?.publishOn}
      />
    </GenericMethods.Update>
  );
}

export default Update;
